/* ============
 * Material Type Transformer
 * ============
 *
 * The transformer for the materialType.
 */

import Transformer from './transformer';

export default class MaterialTypeTransformer extends Transformer {

  static fetch(materialType) {
    return {
      id: materialType.id,
      name: materialType.name,
    };
  }

  static send(materialType) {
    return {
      id: materialType.id,
      name: materialType.name,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/materialType.js